"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _ramda = require("ramda");

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);
var _default = mapIndexed;
exports["default"] = _default;